import React from 'react';
import { Star, ThumbsUp, Quote } from 'lucide-react';

const Reviews = () => {
  const reviews = [
    {
      name: 'Priya Sharma',
      rating: 5,
      date: 'December 2024',
      text: 'Dr. Teja saved our Lilly! She was in critical condition with parvovirus, and we had almost lost hope. But his expertise, dedication, and caring treatment brought her back to health. He explained everything clearly and checked on her progress regularly. Forever grateful to him and his team!',
      highlight: 'Critical Care Success'
    },
    {
      name: 'Rajesh Kumar',
      rating: 5,
      date: 'November 2024',
      text: 'Best veterinary care in Bhimavaram, hands down. The doctor is incredibly knowledgeable and treats every animal with genuine compassion. He doesn\'t just treat symptoms - he takes time to understand the root cause. Highly recommended, especially for emergency cases.',
      highlight: 'Expert Diagnosis'
    },
    {
      name: 'Anita Reddy',
      rating: 5,
      date: 'October 2024',
      text: 'Excellent service! I brought a street dog who was badly injured in an accident. They treated him completely free of charge and with so much care. This is the kind of humanity and compassion we need more of. Bless them!',
      highlight: 'Community Service'
    },
    {
      name: 'Venkat Rao',
      rating: 5,
      date: 'October 2024',
      text: 'My Oreo was suffering from severe stomach issues and we tried multiple vets with no improvement. Dr. Teja diagnosed the problem correctly on the first visit and prescribed the right treatment. Within 3 days, Oreo was back to normal. Professional and caring!',
      highlight: 'Accurate Treatment'
    },
    {
      name: 'Lakshmi Devi',
      rating: 5,
      date: 'September 2024',
      text: 'Our labrador puppy contracted parvo and was in terrible condition. Everyone told us to prepare for the worst, but Dr. Teja fought for him like he was his own pet. After 10 days of intensive care, our baby is now healthy and playful. True lifesaver!',
      highlight: 'Parvovirus Recovery'
    },
    {
      name: 'Srinivas Murthy',
      rating: 5,
      date: 'September 2024',
      text: 'Very impressed with the 24/7 service. Had an emergency at 2 AM when my cat ate something toxic. Called immediately and doctor was available. Quick treatment saved her life. The dedication is remarkable.',
      highlight: '24/7 Emergency'
    },
    {
      name: 'Meena Patel',
      rating: 5,
      date: 'August 2024',
      text: 'Brought my senior dog for a health checkup. The doctor was so gentle and patient with him. Explained all the age-related issues clearly and gave practical advice for care. The staff is also very helpful and kind.',
      highlight: 'Senior Pet Care'
    },
    {
      name: 'Arun Kumar',
      rating: 5,
      date: 'August 2024',
      text: 'Affordable pricing without compromising on quality. They genuinely care about animals, not just making money. The clinic is clean, well-equipped, and the treatment is top-notch. Highly recommend to all pet parents in Bhimavaram!',
      highlight: 'Value for Money'
    },
    {
      name: 'Divya Prasad',
      rating: 5,
      date: 'July 2024',
      text: 'My Persian cat needed grooming and health check. They did an excellent job - she looks beautiful and they also caught an early skin infection during examination. Attention to detail is impressive!',
      highlight: 'Grooming & Care'
    }
  ];

  return (
    <div style={{ paddingTop: '5rem' }}>
      {/* Reviews Hero */}
      <section className="container" style={{ marginTop: '3rem', marginBottom: '4rem', textAlign: 'center' }}>
        <h1 className="heading-1" style={{ marginBottom: '1rem' }}>
          What Pet Parents Say
        </h1>
        <div className="rating-container" style={{ justifyContent: 'center', marginBottom: '1rem' }}>
          <Star size={32} className="star-icon" fill="#FFB800" />
          <span style={{ fontSize: '2rem', fontWeight: '700', color: 'var(--text-primary)' }}>4.8</span>
          <span style={{ fontSize: '1.2rem', color: 'var(--text-secondary)' }}>out of 5</span>
        </div>
        <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
          Based on 269 Google Reviews - Bhimavaram's Most Trusted Veterinary Hospital
        </p>
      </section>

      {/* Statistics */}
      <section style={{ background: 'var(--accent-wash)', padding: '3rem 1.5rem', marginBottom: '4rem' }}>
        <div className="container">
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '2rem',
            textAlign: 'center'
          }}>
            <div>
              <div style={{ fontSize: '2.5rem', fontWeight: '700', color: 'var(--accent-text)' }}>95%</div>
              <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>5-Star Reviews</div>
            </div>
            <div>
              <div style={{ fontSize: '2.5rem', fontWeight: '700', color: 'var(--accent-text)' }}>269+</div>
              <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>Happy Families</div>
            </div>
            <div>
              <div style={{ fontSize: '2.5rem', fontWeight: '700', color: 'var(--accent-text)' }}>1000+</div>
              <div className="body-medium" style={{ color: 'var(--text-secondary)' }}>Pets Treated</div>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="container" style={{ marginBottom: '4rem' }}>
        <div className="ai-grid">
          {reviews.map((review, index) => (
            <div key={index} className="review-card">
              <div style={{ position: 'absolute', top: '16px', right: '16px', opacity: 0.1 }}>
                <Quote size={48} />
              </div>
              <div className="review-header">
                <div>
                  <div className="reviewer-name">{review.name}</div>
                  <div style={{ display: 'flex', gap: '4px', marginTop: '4px', marginBottom: '4px' }}>
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} size={16} fill="#FFB800" color="#FFB800" />
                    ))}
                  </div>
                  <div className="caption">{review.date}</div>
                </div>
              </div>
              {review.highlight && (
                <div style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  background: 'var(--accent-wash)',
                  padding: '4px 12px',
                  borderRadius: '9999px',
                  fontSize: '0.75rem',
                  fontWeight: '600',
                  color: 'var(--accent-text)',
                  marginTop: '8px',
                  marginBottom: '12px'
                }}>
                  <ThumbsUp size={12} />
                  {review.highlight}
                </div>
              )}
              <p className="review-text">"{review.text}"</p>
            </div>
          ))}
        </div>
      </section>

      {/* Google Reviews CTA */}
      <section style={{ background: 'var(--bg-section)', padding: '4rem 1.5rem' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="heading-2" style={{ marginBottom: '1rem' }}>
            Experience the Care Yourself
          </h2>
          <p className="body-large" style={{ marginBottom: '2rem', color: 'var(--text-secondary)' }}>
            Join hundreds of satisfied pet parents who trust us with their beloved companions.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a 
              href="https://www.google.com/search?q=Teja%27s+Pet+Care+Bhimavaram" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn-secondary"
            >
              View on Google
            </a>
            <a href="tel:+918199981444" className="btn-primary">
              Book Appointment
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Reviews;